import Vue from 'vue'
export const QUERY_STORED = 'QUERY_STORED'

const state = { queries:{} }
const getters = {
 
      getQueries: state => state.queries
    }

    const actions = {

        [QUERY_STORED]: ({commit, dispatch},query) => {

            commit(QUERY_STORED, query)
        }
    }

    const mutations = {
        [QUERY_STORED]: (state,resp) => {
            console.log('Mutation',resp)
           //state.dates=resp.dates;
          // state.town=resp.town;
          Vue.set(state, 'queries', resp)
       
        },
        updatecountry(state, country) {
            state.queries.country = country
          },
          updatetown(state, town) {
            state.queries.town = town
          },
          updatedates(state, dates) {
            state.queries.dates = dates
          },
          updatedays(state, days) {
            state.queries.days = days
          }

    }

    export default {
        state,
        getters,
        actions,
       mutations
      }


// WEBPACK FOOTER //
// ./src/store/modules/queries.js